import React, { useEffect, useMemo, useState } from "react";
import {
  Layout,
  Card,
  Button,
  Input,
  Radio,
  Popconfirm,
  Form,
  InputNumber,
  message,
  Select,
  Typography,
  Row,
  Col,
  TimePicker,
  Divider,
} from "antd";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { useSelector } from "react-redux";
import CustomThemeDrawer from "../../../../../Elements/CustomThemeDrawer";
import {
  EditOutlined,
  DeleteOutlined,
  QuestionCircleOutlined,
} from "@ant-design/icons";
import { APIConstants } from "../../../../../../Common/APIConstants";
import { useStoreUpdaterWithAPI } from "../../../../../../Hooks/UseStoreUpdaterWithApi";
const { Title, Text } = Typography;
import dayjs from "dayjs";

const DashEnergy = () => {
  const [open, setOpen] = useState(false);
  const [open2, setOpen2] = useState(false);
  const [open3, setOpen3] = useState(false);
  const [refetch, setRefetch] = useState(false);
  const [refetch2, setRefetch2] = useState(false);
  const [refetch3, setRefetch3] = useState(false);
  const { makeRequest } = useStoreUpdaterWithAPI();
  const [form1] = Form.useForm();
  const [form2] = Form.useForm();
  const [form3] = Form.useForm();
  const showDrawer = () => {
    form1.resetFields()
    setOpen(true);
  };

  const onClose = () => {
    // form1.resetFields()
    setOpen(false);
  };
  const showDrawer2 = () => {
    setOpen2(true);
  };

  const onClose2 = () => {
    // form2.resetFields()
    setOpen2(false);
  };
  const showDrawer3 = () => {
    setOpen3(true);
  };

  const onClose3 = () => {
    // form3.resetFields()
    setOpen3(false);
  };
  const mode = useSelector((state) => state.darkMode);
  const color = useSelector((state) => state.ThemeChange);
  //console.log(color);
  const { isdarkMode } = mode;

  const [externalEnergySources, setExternalEnergySources] = useState([]);
  const [updateExternalEnergySources, setUpdateExternalEnergySources] =
    useState([]);
  const [productionData, setProductionData] = useState([]);
  const [resourceDetails, setResourceDetails] = useState([]);
  const [newExternalSource, setNewExternalSource] = useState("");
  const [newProductionData, setNewProductionData] = useState("");
  const [tariff, setTariff] = useState([]);
  const [tariffSlot, setTariffSlot] = useState([]);
  const [selectedValue, setSelectedValue] = useState("");
  const [selectedSubGroupValue, setSelectedSubGroupValue] = useState("");
  const [groupData, setGroupData] = useState([]);
  const [subGroupData, setSubGroupData] = useState([]);
  const [deviceData, setDeviceData] = useState([]);
  const [groupname, setGroupname] = useState([]);
  const [daystatus, setdaystatus] = useState([]);
  const [subGroup, setSubGroup] = useState([]);
  const [groupID, setGroupId] = useState();
  const [consumptionDetail, setConsumptionDetails] = useState([]);
  const [getFlowConverterResData, setgetFlowConverterResData] = useState([]);
  const [nsGetFlowConverterResData, setnsGetFlowConverterResData] = useState(
    []
  );
  const [timings, setTimings] = useState([]);
  const [updateTariffData, setUpdateTariffData] = useState(false);
  const [updateTariffSlot, setUpdateTariffSlot] = useState(false);
  const [tariffSlotTariffAutoID, setTariffSlotTariffAutoID] = useState(null);
  const [converterGroupId, setConverterGroupId] = useState();
  const [selectedMeterIds, setSelectedMeterIds] = useState([]);
  const [data, setData] = useState([]);

  // // Sub group
  // useEffect(() => {
  //   if (groupID !== undefined) {
  //     makeRequest({
  //       type: APIConstants.POST,
  //       url: `${APIConstants.ELECTRICAL_SUB_GROUPDETAILS}?GroupId=${groupID}`,
  //     })
  //       .then((res) => {
  //         setSubGroup(res);
  //       })
  //       .catch((error) => {
  //         //console.error("Error fetching sub groups:", error);
  //         setSubGroup([]);
  //       });
  //   }
  // }, [groupID]);

  //timings
  useEffect(() => {
    makeRequest({
      type: APIConstants.GET,
      url: `${APIConstants.ELECTRICAL_SHIFT_TIMING}`,
    })
      .then((res) => {
        //console.log(res);
        setTimings(res);
        const time = () => {
          const values = {}; // use object instead of array
          res.forEach((i) => {
            if (i.autoID == 1) {
              //console.log(i.fromDate);
              values.shift1From = dayjs(i.fromDate);
              values.shift1To = dayjs(i.toDate);
            }
            if (i.autoID == 2) {
              values.shift2From = dayjs(i.fromDate);
              values.shift2To = dayjs(i.toDate);
            }
            if (i.autoID == 3) {
              values.shift3From = dayjs(i.fromDate);
              values.shift3To = dayjs(i.toDate);
            }
            if (i.autoID == 4) {
              values.dailyFrom = dayjs(i.fromDate);
              values.dailyTo = dayjs(i.toDate);
            }
          });
          return values;
        };
        const demo = time();
        //console.log(demo);
        if (demo) {
          form.setFieldsValue(time());
        }
        setData(demo);
      })
      .catch((error) => {
        //console.error("Error fetching sub groups:", error);
        setTimings([]);
      });
  }, [refetch]);

  // Converter
  useEffect(() => {
    if (converterGroupId) {
      makeRequest({
        type: APIConstants.GET,
        url: `${APIConstants.ELECTRICAL_METERS_DETAILS}?ConverterID=${converterGroupId}`,
      }).then((res) => {
        setnsGetFlowConverterResData(res);
      });
    }
  }, [converterGroupId]);

  const handleNotification = (msg, type) => {
    message.open({
      content: `${msg}`,
      type: type,
    });
  };

  const getTariff = () => {
    // //console.log(formValues);
    // http://20.244.40.160:92/getGroupDetails?ConverterName=as&ConverterID=1
    const url = `${APIConstants.ELECTRICAL_GET_TARIFF_DETAILS}`;
    //console.log(url);

    makeRequest({
      type: APIConstants.GET,
      url: url,
      // body:formValues
    }).then((res) => {
      //console.log(res);
      if (res) {
        setTariff(res);
      }
    });
  };
  const getTariffSlot = () => {
    // //console.log(formValues);
    // http://20.244.40.160:92/getGroupDetails?ConverterName=as&ConverterID=1
    const url = `${APIConstants.ELECTRICAL_GET_TARIFF_SLOT_DETAILS}`;
    //console.log(url);

    makeRequest({
      type: APIConstants.GET,
      url: url,
      // body:formValues
    }).then((res) => {
      // console.log(res);
      if (res) {
        setTariffSlot(res);
      }
    });
  };
  // const getSubGroup = () => {
  //   //console.log(selectedValue);
  //   const url = `${APIConstants.ELECTRICAL_SUB_GROUP_DETAILS}?GroupId=${selectedValue}`;
  //   // const url = `${APIConstants.DEVICE_DETAILS}`;
  //   //console.log(url);

  //   makeRequest({
  //     type: APIConstants.POST,
  //     url: url,
  //     // body:formValues
  //   }).then((res) => {
  //     //console.log(res);
  //     if (res) {
  //       setSubGroupData(res);
  //     }
  //   });
  // };
  const getDevices = (values) => {
    //console.log("Form values:", values);

    if (values) {
      makeRequest({
        type: APIConstants.GET,
        url: `${APIConstants.ELCTRICAL_SUBGROUP_METER_DETAILS}?SubGroupID=${values}`,
      })
        .then((res) => {
          //console.log("Meter Details:", res);
          if (res && res.length > 0) {
            //  setShowGrid(true);
            setDeviceData(res);
          }
        })
        .catch((err) => {
          //console.error("Error fetching meter details", err);
        });
    } else {
      //console.error("Something went wrong");
    }
  };
  useEffect(() => {
    //console.log(selectedSubGroupValue);
    getDevices(selectedSubGroupValue);
  }, [selectedSubGroupValue]);

  // useEffect(() => {
  //   getSubGroup();
  // }, [selectedValue, refetch3]);
  // useEffect(() => {
  //   makeRequest({
  //     type: APIConstants.GET,
  //     url: `${APIConstants.GET_EXTERNAL_ENERGY_SOURCE}`,
  //   }).then((res) => {
  //     //console.log(res);
  //     function addIsUpdateFlag(sourceArray) {
  //       return sourceArray.map((item) => ({
  //         ...item,
  //         // isUpdate: false,
  //       }));
  //     }

  //     if (res && res.length > 0) {
  //       const updatedSources = addIsUpdateFlag(res); // originalSources is your input array
  //       //console.log(updatedSources);

  //       setExternalEnergySources(updatedSources);
  //       setUpdateExternalEnergySources(updatedSources);
  //     }
  //   });
  // }, [refetch]);
  useEffect(() => {
    // getTariff();
    getTariffSlot();
  }, [refetch2]);

  const deviceCols = [
    { headerName: "S.No", field: "autoID", width: 80 },
    { headerName: "Emission Factor", field: "groupID", flex: 1 },
    { headerName: "Unit Cost ", field: "metername", flex: 1 },

    // {
    //   headerName: "Actions",
    //   width: 150,
    //   cellRenderer: (params) => (
    //     <div className="space-x-2">
    //       <Popconfirm
    //         title="Are you sure to delete this Converter"
    //         icon={<QuestionCircleOutlined style={{ color: "red" }} />}
    //         onConfirm={() => deleteExternalEnergy(params.data)}
    //         trigger="click"
    //       >
    //         <Button className="text-red-500">
    //           <DeleteOutlined />
    //         </Button>
    //       </Popconfirm>
    //     </div>
    //   ),
    // },
  ];

  const tariffSlotCols = [
    // {
    //   headerName: "",
    //   field: "select",
    //   width: 30,
    //   headerCheckboxSelection: false, // optional
    //   cellRenderer: (params) => {
    //     return (
    //       <input
    //         type="checkbox" // Change to "checkbox" if you prefer
    //         name="rowSelect"
    //         defaultChecked={params.data.groupID === selectedValue}
    //         onChange={(e) => {
    //           if (e.target.checked) {
    //             //console.log("Selected Row:", params.data);
    //             setSelectedValue(params.data.groupID);
    //           } else {
    //             //console.log("Unchecked Row:", params.data);
    //           }
    //         }}
    //       />
    //     );
    //   },
    // },
    { headerName: "S No.", field: "groupID", minWidth: 70, flex: 1 },
    { headerName: "Tariff Slot", field: "tariffSlot", minWidth: 100, flex: 1 },
    { headerName: "Unit Cost", field: "unitCost", minWidth: 100, flex: 1 },
    { headerName: "From", field: "fromdtime", minWidth: 110, flex: 1 },
    { headerName: "To", field: "totime", minWidth: 110, flex: 1 },
    {
      headerName: "Actions",
      minWidth: 130,
      flex: 1,
      cellRenderer: (params) => {
        return (
          <div className="space-x-2">
            <span
  className="text-green-500 bg-green-200 p-2 cursor-pointer shadow-lg rounded-md px-4 
             transition-transform duration-200 hover:border-[1px] border-green-400"
              onClick={() => {
                setOpen(true);
                setUpdateTariffSlot(true);
                //console.log(params.data.groupID);
                //console.log(params.data);
                setTariffSlotTariffAutoID(params.data.tariffAutoID)
                //console.log(groupname);
                //console.log(groupname.find((i) => i.groupID == params.data.groupID));
                const selectedGroup = groupname.find((i) => i.groupID === params.data.groupID);
                form1.setFieldsValue({
                  groupID: selectedGroup? { key: selectedGroup.groupID, value: selectedGroup.department }: undefined,
                  tariffSlot: params.data.tariffSlot,
                  unitCost: params.data.unitCost,
                  fromTime: dayjs(params.data.fromdtime, "HH:mm:ss"),
                  toTime: dayjs(params.data.totime, "HH:mm:ss"),
                  day: params.data.dayStatus
                });
              }}
            >
              <EditOutlined />
            </span>

            <Popconfirm
              title="Are you sure to delete?"
              // description="Are you sure to delete this Converter Configuration?"
              icon={<QuestionCircleOutlined style={{ color: "red" }} />}
              onConfirm={() => deleteTariffSlot(params.data)}
              trigger="click"
            >
              <span
  className="text-red-500 bg-red-200 p-2 cursor-pointer shadow-lg rounded-md px-4 
             transition-transform duration-200 hover:border-[1px] border-red-400">
                <DeleteOutlined />
              </span>
            </Popconfirm>
          </div>
        );
      },
    },
  ];

  const tariffCols = [
    // {
    //   headerName: "",
    //   field: "select",
    //   width: 30,
    //   headerCheckboxSelection: false, // optional
    //   cellRenderer: (params) => {
    //     return (
    //       <input
    //         type="checkbox" // Change to "checkbox" if you prefer
    //         name="rowSelect"
    //         defaultChecked={params.data.groupID === selectedSubGroupValue}
    //         onChange={(e) => {
    //           if (e.target.checked) {
    //             //console.log("Selected Row:", params.data);
    //             setSelectedSubGroupValue(params.data.subGroupID);
    //           } else {
    //             //console.log("Unchecked Row:", params.data);
    //           }
    //         }}
    //       />
    //     );
    //   },
    // },
    { headerName: "S No.", field: "tariffAutoID", minWidth: 70,flex:1 },
    {
      headerName: "Tariff Details",
      field: "tariffName",
      minWidth: 130,
      flex: 1,
    },
    { headerName: "Unit Cost", field: "unitCost", minWidth: 110, flex: 1 },
    {
      headerName: "Actions",
      minWidth: 130,
      flex: 1,
      cellRenderer: (params) => {
        return (
          <div className="space-x-2">
             <span
  className="text-green-500 bg-green-200 p-2 cursor-pointer shadow-lg rounded-md px-4 transition-transform duration-200 hover:border-[1px] border-green-400"
              onClick={() => {
                setOpen2(true);
                setUpdateTariffData(true);
                form2.setFieldsValue({
                  tariffAutoID: params.data.tariffAutoID,
                  tariffName: params.data.tariffName,
                  unitCost: params.data.unitCost,
                });
              }}
            >
              <EditOutlined />
            </span>

            <Popconfirm
              title="Are you sure to delete ?"
              // description="Are you sure to delete this Converter Configuration?"
              icon={<QuestionCircleOutlined style={{ color: "red" }} />}
              onConfirm={() => deleteTariff(params.data)}
              trigger="click"
            >
               <span
  className="text-red-500 bg-red-200 p-2 cursor-pointer shadow-lg rounded-md px-4 
             transition-transform duration-200 hover:border-[1px] border-red-400">
                <DeleteOutlined />
              </span>
            </Popconfirm>
          </div>
        );
      },
    },
  ];

  const onFinish2 = (values) => {
    //console.log(values);
    if (updateTariffData) {
      //   setFormValues(values);
      //console.log(values);
      updateTariff(values);
    } else {
      form2.resetFields();
      //console.log(values); // Log the form values
      //   handleOk();
      insertTariff(values);
    }
  };

  const insertTariff = (formValues) => {
    //console.log(formValues);
    const body = {
      // tariffAutoID: formValues.tariffAutoID,
      tariffName: formValues.tariffName,
      unitCost: formValues.unitCost,
    };
    const url = `${APIConstants.ELECTRICAL_INSERT_TARIFF_DETAILS}`;
    //console.log(url);
    makeRequest({
      type: APIConstants.POST,
      url: url,
      body: body,
    }).then((res) => {
      setRefetch2(!refetch2);
      onClose2();
      handleNotification(res?.message, res?.message.includes('success')? "success":"error");
      //console.log(res?.message);
    });
  };
  const updateTariff = (formValues) => {
    //console.log(formValues);
    const body = {
      tariffAutoID: formValues.tariffAutoID,
      // tariffName: formValues.tariffName,
      unitCost: formValues.unitCost,
    };
    //console.log(body);
    const url = `${APIConstants.ELECTRICAL_UPDATE_TARIFF_DETAILS}`;
    //console.log(url);

    makeRequest({
      type: APIConstants.POST,
      url: url,
      body: body,
    }).then((res) => {
      setRefetch2(!refetch2);
      onClose2();
      form2.resetFields();
      setUpdateTariffData(false);
      handleNotification(res?.message, res?.message.includes('success')? "success":"error");
      //console.log(res?.message);
    });
  };
  const deleteTariffSlot = (formValues) => {
    //console.log(formValues);

    const body = {
      tariffAutoID: formValues.tariffAutoID,
    };

    const url = `${APIConstants.ELECTRICAL_DELETE_TARIFF_SLOT_DETAILS}`;

    //console.log(url);
    //console.log(body);

    makeRequest({
      type: APIConstants.POST,
      url: url,
      body: body,
    }).then((res) => {
      //console.log(res);
      onClose2();
      setRefetch2(!refetch2);
      handleNotification("Successfully Deleted", "success");
    });
  };

  const onFinish3 = (values) => {
    // setFormValues(values);
    //console.log(values);
    const formData = (values) => {
      return {
        groupID: values.groupID?.key || null,
        subGroupType: "Plus" || null,
        subGroupName: values.subGroupName || null,
      };
    };
    const formValues = formData(values);
    //console.log(formValues);
    onClose3();
    insertDevice(formValues);
    form3.resetFields(); // Reset form fields after submission
  };

  const insertDevice = (formValues) => {
    //console.log(formValues);
    const url = `${APIConstants.ELECTRICAL_INSERT_SUB_GROUP}`;
    //console.log(url);

    makeRequest({
      type: APIConstants.POST,
      url: url,
      body: formValues,
    })
      .then((res) => {
        //console.log(res);
        // setRefetch3(!refetch3)

        handleNotification("Sub Group added successfully!", "success");
      })
      .catch((err) => {
        handleNotification("Something went wrong!", "error");
      });
  };
  const deleteTariff = (formValues) => {
    //console.log(formValues);
    // setSelectedValue(formValues.groupID)

    const body = {
      tariffAutoID: formValues.tariffAutoID,
    };

    const url = `${APIConstants.ELECTRICAL_DELETE_TARIFF_DETAILS}`;

    //console.log(url);
    //console.log(body);

    makeRequest({
      type: APIConstants.DELETE,
      url: url,
      body: body,
    }).then((res) => {
      //console.log(res);
      setRefetch2(!refetch2);
      handleNotification(res.message, "success");
    });
  };
  const insertTariffSlot =(values)=>{
     const transformedData = {
      groupID: parseInt(values.groupID?.key) || null,
      tariffSlot: values?.tariffSlot || null,
      day: values?.day?.value || null,
      unitCost: values?.unitCost || null,
      fromTime: values.fromTime ? values.fromTime.format("HH:mm:ss") : null,
      toTime: values.toTime ? values.toTime.format("HH:mm:ss") : null,
    };

    //console.log("Transformed Data to Submit:", transformedData);

    makeRequest({
      type: APIConstants.POST,
      url: `${APIConstants.ELECTRICAL_INSERT_TARIFF_SLOT_DETAILS}`,
      body: transformedData,
    })
      .then((res) => {
        console.log("API Response:", res);
        //console.log("Transformed Data:", transformedData);
        // message.success(res.message);
        handleNotification(res.message,res?.message.includes('Successfully')? "success":"error")

        onClose();
        form1.resetFields();
        // setRefetch(!refetch);
        getTariffSlot();
      })
      .catch((error) => {
        //console.error("Error saving Group Config:", error);
      });
  }
  const updateTariffSlots =(values)=>{
    //console.log(values)
    //console.log(tariffSlotTariffAutoID)
     const transformedData = {
      tariffAutoID:parseInt(tariffSlotTariffAutoID),
      groupID: parseInt(values.groupID?.key) || null,
      tariffSlot: values?.tariffSlot || null,
      unitCost: values?.unitCost || 0,
      day: values?.day?.value || values?.day,
      fromTime: values.fromTime ? values.fromTime.format("HH:mm:ss") : null,
      toTime: values.toTime ? values.toTime.format("HH:mm:ss") : null,
    };

    //console.log("Transformed Data to Submit:", transformedData);

    makeRequest({
      type: APIConstants.POST,
      url: `${APIConstants.ELECTRICAL_UPDATE_TARIFF_SLOT_DETAILS}`,
      body: transformedData,
    })
      .then((res) => {
        console.log("API Response:", res);
        //console.log("Transformed Data:", transformedData);
        message.success("Tariff slot updated successfully!");

        onClose();
        form1.resetFields();
        setUpdateTariffSlot(false)
        // setRefetch(!refetch);
        getTariffSlot();
      })
      .catch((error) => {
        //console.error("Error saving Group Config:", error);
      });
  }
  const onFinish1 = (values) => {
    //console.log(values);

    const transformedData = {
      groupID: parseInt(values.groupID?.key) || null,
      tariffSlot: values?.tariffSlot || null,
      day: values?.day?.value || null,
      unitCost: values?.unitCost || null,
      fromTime: values.fromTime ? values.fromTime.format("HH:mm:ss") : null,
      toTime: values.toTime ? values.toTime.format("HH:mm:ss") : null,
    };

    //console.log("Transformed Data to Submit:", transformedData);
 //console.log(values);
 //console.log(updateTariffSlot)
    if (updateTariffSlot) {
      //   setFormValues(values);
      //console.log(values);
      updateTariffSlots(values);
    } else {
      form1.resetFields();
      //console.log(values); 
      //   handleOk();
      insertTariffSlot(values);
    }
    
  };

  //console.log(externalEnergySources);

  //console.log(productionData);
  //console.log(resourceDetails);
  const handleMeterChange = (selectedKeys) => {
    const selectedMeters = selectedKeys
      .map((selectedKey) => {
        const meter = nsGetFlowConverterResData.find(
          (meter) => meter.meterid === selectedKey
        );
        return meter
          ? { meterId: meter.meterid, meterName: meter.metername }
          : null;
      })
      .filter(Boolean);

    setSelectedMeterIds(selectedMeters);
  };
  useEffect(() => {
    setDeviceData([]);
    setSelectedSubGroupValue("");
  }, [selectedValue]);

  const [form] = Form.useForm();
  const mapShiftsToArray = (input) => {
    const shifts = [
      { autoID: 1, fromKey: "shift1From", toKey: "shift1To" },
      { autoID: 2, fromKey: "shift2From", toKey: "shift2To" },
      { autoID: 3, fromKey: "shift3From", toKey: "shift3To" },
      { autoID: 4, fromKey: "dailyFrom", toKey: "dailyTo" },
    ];

    return shifts.map(({ autoID, fromKey, toKey }) => ({
      autoID,
      fromDate: convertToISO(input[fromKey]),
      toDate: convertToISO(input[toKey]),
    }));
  };

const convertToISO = (timeString) => {
  const now = new Date();
  const [time, modifier] = timeString.split(" ");
  let [hours, minutes] = time.split(":").map(Number);

  if (modifier === "PM" && hours !== 12) hours += 12;
  if (modifier === "AM" && hours === 12) hours = 0;

  const date = new Date(
    now.getFullYear(),
    now.getMonth(),
    now.getDate(),
    hours,
    minutes
  );

  // ✅ Format as "YYYY-MM-DDTHH:mm:ss" in LOCAL time (not UTC)
  const yyyy = date.getFullYear();
  const mm = String(date.getMonth() + 1).padStart(2, "0");
  const dd = String(date.getDate()).padStart(2, "0");
  const hh = String(date.getHours()).padStart(2, "0");
  const min = String(date.getMinutes()).padStart(2, "0");
  const ss = String(date.getSeconds()).padStart(2, "0");

  return `${yyyy}-${mm}-${dd}T${hh}:${min}:${ss}`;
};



  const onFinish = (values) => {
    // Convert moment objects to string for readable output
    const formatted = Object.entries(values).reduce((acc, [key, value]) => {
      acc[key] = value ? value.format("hh:mm A") : null;
      return acc;
    }, {});
    console.log("Submitted values:", formatted);

    // const transformedData = {
    //   groupID: parseInt(values.groupID?.key) || null,
    //   tariffSlot: values.tariffSlot || null,
    //   fromTime: values.fromTime ? values.fromTime.format("HH:mm") : null,
    //   toTime: values.toTime ? values.toTime.format("HH:mm") : null,
    // };

    console.log(mapShiftsToArray(formatted));

    // //console.log("Transformed Data to Submit:", transformedData);

    makeRequest({
      type: APIConstants.PUT,
      url: `${APIConstants.ELECTRICAL_UPDATE_SHIFT_TIMING}`,
      body: mapShiftsToArray(formatted),
    })
      .then((res) => {
        //console.log("API Response:", res);
        message.success("Timings updated successfully!");
        onClose();
        form1.resetFields();
        setRefetch(!refetch);
      })
      .catch((error) => {
        //console.error("Error updating timings:", error);
      });

    // Reset form
    form.resetFields();
  };

  useEffect(() => {
    //  Group Name
    makeRequest({
      type: APIConstants.POST,
      url: `${APIConstants.ELECTRICAL_GROUP_NAME}`,
    }).then((res) => {
      //console.log(res);
      if (res) {
        setGroupname(res);
      }
    });
    // daystatus
    makeRequest({
      type: APIConstants.GET,
      url: `${APIConstants.ELECTRICAL_GET_DAY_STATUS}`,
    }).then((res) => {
      //console.log(res);
      if (res) {
        setdaystatus(res);
      }
    });
  }, []);

  return (
    <div
      className={`p-4 min-h-screen  ${isdarkMode ? "bg-transparent text-white" : "bg-white text-black"}`}
    >
      <div>
        <h2
          className={`pb-0 text-left text-3xl font-[500] ml-0 tracking-[1px] ${
            isdarkMode ? "text-white" : "text-black"
          }`}
        >
          Dash Energy
        </h2>

        <div className="flex gap-4 h-[100vh]">
          <div className="w-2/3 flex-col gap-2 flex ">
            <Card
              title={
                <span className={isdarkMode ? "text-white" : "text-black"}>
                  Timings
                </span>
              }
              className={`${isdarkMode?'bg-transparent':'bg-white'} overflow-y-scroll w-full h-[90vh]`}
            >
              <Form
                layout="vertical"
                className="w-full"
                form={form}
                onFinish={onFinish}
              >
                {/* Daily Timings */}
                <Title style={{color:isdarkMode?"white":"black"}} level={5}>Daily Timings</Title>
                <Row gutter={16}>
                  <Col span={12}>
                    <Form.Item
                      name="dailyFrom"
                      // label="From"
                      label={<span className={isdarkMode ? "text-white" : "text-black"}>From</span>}
                      rules={[
                        {
                          required: true,
                          message: "Please select From Time",
                        },
                      ]}
                    >
                      <TimePicker
                        use12Hours
                        format="hh:mm A"
                        style={{ width: "100%" }}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      name="dailyTo"
                      // label="To"
                      label={<span className={isdarkMode ? "text-white" : "text-black"}>To</span>}
                      rules={[
                        {
                          required: true,
                          message: "Please select To Time",
                        },
                      ]}
                    >
                      <TimePicker
                        use12Hours
                        format="hh:mm A"
                        style={{ width: "100%" }}
                      />
                    </Form.Item>
                  </Col>
                </Row>

                <Divider className="my-0" />

                {/* Shift 1 */}
                <Title style={{color:isdarkMode?"white":"black"}} level={5}>Shift Timing</Title>
                <Text style={{color:isdarkMode?"white":"black"}} strong>Shift 1</Text>
                <Row gutter={16}>
                  <Col span={12}>
                    <Form.Item
                      name="shift1From"
                      // label="From"
                      label={<span className={isdarkMode ? "text-white" : "text-black"}>From</span>}

                      rules={[
                        {
                          required: true,
                          message: "Please select From Time",
                        },
                      ]}
                    >
                      <TimePicker
                        use12Hours
                        format="hh:mm A"
                        style={{ width: "100%" }}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      name="shift1To"
                      // label="To"
                      label={<span className={isdarkMode ? "text-white" : "text-black"}>To</span>}

                      rules={[
                        {
                          required: true,
                          message: "Please select To Time",
                        },
                      ]}
                    >
                      <TimePicker
                        use12Hours
                        format="hh:mm A"
                        style={{ width: "100%" }}
                      />
                    </Form.Item>
                  </Col>
                </Row>

                <Divider />

                {/* Shift 2 */}
                <Text style={{color:isdarkMode?"white":"black"}} strong>Shift 2</Text>
                <Row gutter={16}>
                  <Col span={12}>
                    <Form.Item
                      name="shift2From"
                      label={<span className={isdarkMode ? "text-white" : "text-black"}>From</span>}                      
                      rules={[
                        {
                          required: true,
                          message: "Please select From Time",
                        },
                      ]}
                    >
                      <TimePicker
                        use12Hours
                        format="hh:mm A"
                        style={{ width: "100%" }}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      name="shift2To"
                       label={<span className={isdarkMode ? "text-white" : "text-black"}>To</span>}
                      rules={[
                        {
                          required: true,
                          message: "Please select To Time",
                        },
                      ]}
                    >
                      <TimePicker
                        use12Hours
                        format="hh:mm A"
                        style={{ width: "100%" }}
                      />
                    </Form.Item>
                  </Col>
                </Row>

                <Divider />

                {/* Shift 3 */}
                <Text style={{color:isdarkMode?"white":"black"}} strong>Shift 3</Text>
                <Row gutter={16}>
                  <Col span={12}>
                    <Form.Item
                      name="shift3From"
                      label={<span className={isdarkMode ? "text-white" : "text-black"}>From</span>}
                      rules={[
                        {
                          required: true,
                          message: "Please select From Time",
                        },
                      ]}
                    >
                      <TimePicker
                        use12Hours
                        format="hh:mm A"
                        style={{ width: "100%" }}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      name="shift3To"
                      label={<span className={isdarkMode ? "text-white" : "text-black"}>To</span>}
                      rules={[
                        {
                          required: true,
                          message: "Please select To Time",
                        },
                      ]}
                    >
                      <TimePicker
                        use12Hours
                        format="hh:mm A"
                        style={{ width: "100%" }}
                      />
                    </Form.Item>
                  </Col>
                </Row>

                <Form.Item style={{ textAlign: "center", marginTop: 16 }}>
                  <Button
                    onClick={() => form.resetFields()}
                    type="primary"
                    className="mr-3"
                  >
                    Clear
                  </Button>
                  <Button type="primary" htmlType="submit">
                    Update
                  </Button>
                </Form.Item>
              </Form>
            </Card>

           
          </div>

          {/* Tariff slots */}
           <Card
              title={
                <span className={isdarkMode ? "text-white" : "text-black"}>
                  Tariff Slots
                </span>
              }
              extra={
                <Button type="primary" onClick={() =>{
                  setUpdateTariffSlot(false)
                  showDrawer()}}>
                  Add +
                </Button>
              }
              className={`w-2/3 h-[90vh] rounded-md overflow-hidden shadow ${isdarkMode ? "bg-transparent" : "bg-white"}`}
              bodyStyle={{ padding: 0 }}
            >
              <div
                className={`${isdarkMode ? "ag-theme-quartz-dark" : "ag-theme-alpine"}`}
                style={{
                  "--ag-header-background-color":
                    color.themeConfig.colorPrimary,
                  "--ag-header-foreground-color": "#fff",
                  "--ag-header-group-bg": color.themeConfig.colorPrimaryShade, // custom var
                  height: "90vh",
                  width: "100%",
                  overflowY: "auto",
                }}
              >
                <AgGridReact
                  rowData={tariffSlot}
                  columnDefs={tariffSlotCols}
                  domLayout="normal"
                />
              </div>
            </Card>
          {/* <Card
            title={
              <span className={isdarkMode ? "text-white" : "text-black"}>
                Costing For Energy
              </span>
            }
            extra={
              <Button type="primary" onClick={() => {
                setUpdateTariffData(false)
                showDrawer2()}}>
                Add +
              </Button>
            }
            className={`w-1/3 rounded-md overflow-hidden shadow ${isdarkMode ? "bg-transparent" : "bg-white"}`}
            bodyStyle={{ padding: 0 }}
          >
            <div
              className={`${isdarkMode ? "ag-theme-quartz-dark" : "ag-theme-alpine"} overflow-x-scroll`}
              style={{
                "--ag-header-background-color": color.themeConfig.colorPrimary,
                "--ag-header-foreground-color": "#fff",
                "--ag-header-group-bg": color.themeConfig.colorPrimaryShade, // custom var
                height: "90vh",
                width: "100%",
                overflowY: "auto",
              }}
            >
              <AgGridReact
                rowData={tariff}
                columnDefs={tariffCols}
                domLayout="normal"
              />
            </div>
          </Card> */}
          {/* Emission Factors */}
          <Card
            title={
              <span className={isdarkMode ? "text-white" : "text-black"}>
                Emission Factors
              </span>
            }
            extra={
              <Button type="primary" onClick={() => showDrawer3()}>
                Add +
              </Button>
            }
            className={`w-1/3 h-[90vh] rounded-md overflow-hidden shadow ${isdarkMode ? "bg-transparent" : "bg-white"}`}
            bodyStyle={{ padding: 0 }}
          >
            <div
              className={`${isdarkMode ? "ag-theme-quartz-dark" : "ag-theme-alpine"}`}
              style={{
                "--ag-header-background-color": color.themeConfig.colorPrimary,
                "--ag-header-foreground-color": "#fff",
                "--ag-header-group-bg": color.themeConfig.colorPrimaryShade, // custom var
                height: "80vh",
                width: "100%",
                overflowY: "auto",
              }}
            >
              <AgGridReact
                rowData={deviceData}
                columnDefs={deviceCols}
                domLayout="normal"
                rowHeight={50}
              />
            </div>
          </Card>
        </div>
      </div>

      <CustomThemeDrawer
        title="Close"
        showDrawer={showDrawer}
        open={open}
        onClose={onClose}
      >
        <div className="flex flex-col gap-6 mt-2">
          <Form
            form={form1}
            name="add-Group-Config"
            layout="horizontal"
            style={{
              maxWidth: 600,
            }}
            labelCol={{
              span: 8,
            }}
            labelAlign="left"
            onFinish={onFinish1}
            className="p-3"
          >
            {/* Group Name */}
            <Form.Item
              // label="Group Name"
               label={
                <span className={isdarkMode ? "text-white" : "text-black"}>
                  Group Name
                </span>
              }
              name="groupID"
              rules={[
                { required: true, message: "Please select Consumption!" },
              ]}
            >
              <Select
                // value={selectedValue}
                // onChange={handleChange}
                // style={{ width: 200 }}
                labelInValue
                placeholder="Select a group"
                dropdownClassName={
                  isdarkMode
                    ? "select-dropdown-background"
                    : "light-mode-dropdown"
                }
                className={`  ${isdarkMode ? "custom-select-dark select-dropdown-background" : "custom-select-light"} w-80 `}
              >
                {groupname.map((i) => (
                  <Option key={i.groupID} value={i.department}>
                    {i.department}
                  </Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item
              // label="Tariff Slot"
               label={
                <span className={isdarkMode ? "text-white" : "text-black"}>
                  Tariff Slot
                </span>
              }
              name="tariffSlot"
              rules={[{ required: true, message: "Please fill  Tariff Slot!" }]}
            >
              <Input
              placeholder="Enter a tariff slot"
               className={
                  isdarkMode ? "dark-input-number" : "light-input-number"
                }
                style={{
                  width: "100%",
                }}
              />
            </Form.Item>

            {/* From TIme */}
            <Form.Item
              // label="From Time"
               label={
                <span className={isdarkMode ? "text-white" : "text-black"}>
                  From Time
                </span>
              }
              name="fromTime"
              rules={[{ required: true, message: "Please select Sub Group!" }]}
            >
              <TimePicker
                  // popupClassName="custom-picker"
               className={`customTimePicker w-80 ml-0 shadow-lg rounded-3xl ${
    isdarkMode ? "customTimePicker-dark" : "customTimePicker-light"
  }`}
                use12Hours
                format="hh:mm:ss"
                style={{ width: "100%" }}
              />
            </Form.Item>

            {/* To Time */}
            <Form.Item
              // label="To Time"
               label={
                <span className={isdarkMode ? "text-white" : "text-black"}>
                  To  Time
                </span>
              }
              name="toTime"
              rules={[
                { required: true, message: "Please select Converter Name!" },
              ]}
            >
              <TimePicker
                // popupClassName="custom-picker"
               className={`customTimePicker w-80 ml-0 shadow-lg rounded-3xl ${
    isdarkMode ? "customTimePicker-dark" : "customTimePicker-light"
  }`}
                use12Hours
                format="hh:mm:ss"
                style={{ width: "100%" }}
              />
            </Form.Item>
              {/* unit cost  */}
              <Form.Item
              // label="Unit Cost"
               label={
                <span className={isdarkMode ? "text-white" : "text-black"}>
                  Unit Cost
                </span>
              }
              name="unitCost"
              rules={[{ required: true, message: "Please input Group ID!" }]}
            >
              <InputNumber placeholder="Enter unit cost"
               className={
                  isdarkMode ? "dark-input-number" : "light-input-number"
                }
                 style={{ width: "100%" }} />
            </Form.Item>

            {/* Day */}
            <Form.Item
              // label="Day"
               label={
                <span className={isdarkMode ? "text-white" : "text-black"}>
                  Day
                </span>
              }
              name="day"
              rules={[{ required: true, message: "Please select day!" }]}
            >
              <Select
                // value={selectedValue}
                // onChange={handleChange}
                // style={{ width: 200 }}
                labelInValue
                placeholder="Select a group"
                dropdownClassName={
                  isdarkMode
                    ? "select-dropdown-background"
                    : "light-mode-dropdown"
                }
                className={`  ${isdarkMode ? "custom-select-dark select-dropdown-background" : "custom-select-light"} w-80 `}
              >
                {daystatus.map((i) => (
                  <Option key={i.dayType} value={i.dayType}>
                    {i.dayType}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Form>

          <div className="flex justify-between gap-4  w-full absolute bottom-0 right-0 p-4">
            <Button onClick={onClose} className="">
              Cancel
            </Button>
            <Button type="primary" onClick={() => form1.submit()}>
              {updateTariffSlot? "Update":"Add"}
            </Button>
          </div>
        </div>
      </CustomThemeDrawer>

      <CustomThemeDrawer
        title="Close"
        showDrawer={showDrawer2}
        open={open2}
        onClose={onClose2}
      >
        <div className="flex flex-col gap-6 mt-2">
          <Form
            form={form2}
            name="Group-add-form"
            // className="font-bold"
            layout="horizontal"
            style={{ maxWidth: 600 }}
            labelCol={{ span: 8, offset: 0 }}
            labelAlign="left"
            onFinish={onFinish2}
          >
            <Form.Item
              className="hidden"
              label="Tariff Details"
              name="tariffAutoID"

              // rules={[{ required: true, message: "Please input department!" }]}
            >
              <Input className="ml-0 " />
            </Form.Item>
            <Form.Item
              label="Tariff Details"
              name="tariffName"
              rules={[{ required: true, message: "Please input department!" }]}
            >
              <Input className="ml-0" />
            </Form.Item>

            <Form.Item
              label="Unit Cost"
              name="unitCost"
              rules={[{ required: true, message: "Please input Group ID!" }]}
            >
              <InputNumber style={{ width: "100%" }} />
            </Form.Item>
          </Form>

          <div className="flex justify-between gap-4  w-full absolute bottom-0 right-0 p-4">
            <Button onClick={onClose2} className="">
              Cancel
            </Button>
            <Button
              // htmlType="submit"
              type="primary"
              //   disabled={!newProductionData.trim()}
              onClick={() => form2.submit()}
            >
              {updateTariffData?"Update":"Add"}
            </Button>
          </div>
        </div>
      </CustomThemeDrawer>
      <CustomThemeDrawer
        title="Close"
        showDrawer={showDrawer3}
        open={open3}
        onClose={onClose3}
      >
        <div className="flex flex-col gap-6 mt-2">
          <Form
            form={form3}
            name="Group-add-form"
            className="font-bold"
            layout="horizontal"
            style={{
              maxWidth: 600,
            }}
            labelCol={{
              span: 8,
              offset: 0,
            }}
            labelAlign="left"
            onFinish={onFinish3}
          >
            <Form.Item
              label="Emission Factor"
              name="groupID"
              rules={[
                {
                  required: true,
                  message: "Please select a group!",
                },
              ]}
            >
              <Select
                // value={selectedValue}
                // onChange={handleChange}
                // style={{ width: 200 }}
                labelInValue
                placeholder="Select a group"
                dropdownClassName={
                  isdarkMode
                    ? "select-dropdown-background"
                    : "light-mode-dropdown"
                }
                className={`  ${isdarkMode ? "custom-select-dark select-dropdown-background" : "custom-select-light"} w-80 `}
              >
                {groupData.map((i) => (
                  <Option key={i.groupID} value={i.department}>
                    {i.department}
                  </Option>
                ))}
              </Select>
            </Form.Item>

            <Form.Item
              label="Unit Cost"
              name="subGroupName"
              rules={[
                {
                  required: true,
                  message: "Please input Group ID!",
                },
              ]}
            >
              <Input
                style={{
                  width: "100%",
                }}
              />
            </Form.Item>
          </Form>

          <div className="flex justify-between gap-4  w-full absolute bottom-0 right-0 p-4">
            <Button onClick={onClose3} className="">
              Cancel
            </Button>
            <Button type="primary" onClick={() => form3.submit()}>
              Add
            </Button>
          </div>
        </div>
      </CustomThemeDrawer>
    </div>
  );
};

export default DashEnergy;
